import {Injectable} from '@angular/core';
import {UAParser} from 'ua-parser-js';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {WebsiteTrackingControllerService} from '@api/utisha-backend';
import {logUtishaError} from '../util/log';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  userAgent = new UAParser().getResult();

  constructor(private router: Router,
              private backend: WebsiteTrackingControllerService) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(e => this.track(e as NavigationEnd));
  }

  track(event: NavigationEnd): void {
    try {
      const [url, params] = event.urlAfterRedirects.split('?');
      this.backend.trackRequest({
        url,
        params,
        browserName: this.userAgent.browser.name,
        browserVersion: this.userAgent.browser.version,
        deviceModel: this.userAgent.device.model,
        deviceType: this.userAgent.device.type,
        deviceVendor: this.userAgent.device.vendor,
        engine: this.userAgent.engine.name,
        os: this.userAgent.os.name,
        osVersion: this.userAgent.os.version
      }).subscribe(() => {
      }, () => {
      });
    } catch (e: any) {
      logUtishaError(`Error while tracking request `, e)
    }
  }

}
